import { ErrorDetails } from './ErrorDetails';
import { Logger } from './Logger';
import { errorToStackString } from './utils';

type Left = { type: 'left'; value: ErrorDetails };
type Right<T> = { type: 'right'; value: T };
type Either<T> = Left | Right<T>;
// type EitherOfParams<T> = {
//   fn: () => T;
type EitherOfParams = {
  fn: () => void | unknown;
  source: string;
  message: string;
  correlationId?: string;
};
type AsyncEitherOfParams<T> = {
  promise: Promise<T>;
  source: string;
  message: string;
  correlationId?: string;
};

const leftFrom = (
  source: string,
  message: string,
  correlationId?: string,
  stacktrace?: string
): Left => ({
  type: 'left',
  value: new ErrorDetails(source, message, correlationId, stacktrace)
});

const either = <T>(value: T): Either<T> => ({ type: 'right', value });

const asyncEitherOf = async <T>(
  promise: Promise<T>,
  source: string,
  message: string,
  correlationId?: string
): Promise<Either<T>> => {
  try {
    // const result = await promise;
    const res = either(await promise);
    return res;
  } catch (error: unknown) {
    const stacktrace = errorToStackString(error);
    Logger.error({ source, message, correlationId, stacktrace });
    return leftFrom(source, message, correlationId, stacktrace);
  }
};

const eitherOf = <T>(
  fn: () => T,
  source: string,
  message: string,
  correlationId?: string
): Either<T> => {
  try {
    return either(fn());
  } catch (error: unknown) {
    const stacktrace = errorToStackString(error);
    Logger.error({ source, message, correlationId, stacktrace });
    return leftFrom(source, message, correlationId, stacktrace);
  }
};

export {
  type Either,
  type EitherOfParams,
  type AsyncEitherOfParams,
  either,
  eitherOf,
  asyncEitherOf,
  type Left,
  leftFrom
};
